import { useNavigate } from 'react-router-dom';
import { SideNav } from '@WESCO-International/wdp-ui-components/components/sidenav';
import { SideMenuData } from '@WESCO-International/wdp-ui-components/components/sidenav/types';
import { MdHome } from 'react-icons/md';
import { MdDomain } from '@WESCO-International/react-svg-icons/md/MdDomain';

export const navLinks: SideMenuData[] = [
  {
    label: 'Catalog',
    iconLeft: <MdHome />,
  },
  {
    label: 'Domain',
    iconLeft: <MdDomain />,
  },
];

interface SidePanelProp {
  navLinks: SideMenuData[];
  activeMenu: string;
}

export function SidePanel({ navLinks, activeMenu }: SidePanelProp) {
  const navigate = useNavigate();
  const labelToPath: Record<string, string> = {
    Catalog: '/catalog',
    Domain: '/domains',
  };
  const handleMenuSelect = (label: string) => {
    const path = labelToPath[label] || '/';
    navigate(path);
  };
  return (
    <div style={{ height: '100vh' }}>
      <SideNav
        id="appsidepanelmenu"
        onMenuSelect={handleMenuSelect}
        items={navLinks}
        activeMenu={activeMenu}
        width={250}
        collapsed={false}
        style={{ fontSize: '0.875rem', height: '100%' }}
      />
    </div>
  );
}
